import React from "react";
import GameAuthor from "../../../../components/GameAuthor";
import "./style.scss";
import { useTranslation } from "react-i18next";
import text from "../../../../locales/ru/ru.json";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../../../components/BaseButton";

export default function SectionWelcome() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="ads-section-welcome">
      <div className="ads-section-welcome__title">
        <h2>{t("ads_section_welcome.welcome")}</h2>
      </div>
      <div className="ads-section-welcome__description">
        <div className="ads-section-welcome__description__text">
          <p>{t("ads_section_welcome.description.part_one")}</p>
          <div className="section-recommendations__recommendation__desc">
            <div className="section-recommendations__recommendation__desc_narrow">
              <p>{t("ads_section_recommendations.if")}</p>
              <br />
            </div>
            <ul className="recommendations-list">
              {text.ads_section_recommendations.reasons.map((recommend, i) => {
                return (
                  <li className="recommendations-list__item" key={i}>
                    {t(`ads_section_recommendations.reasons.${i}.desc`)}
                  </li>
                );
              })}
            </ul>
          </div>
          <p>{t("ads_section_welcome.description.part_two")}</p>
          <p>{t("ads_section_welcome.description.part_three")}</p>
        </div>
        <GameAuthor />
      </div>
      <div>
        <div className="ads-section-welcome__want-more">
          <p className="ads-section-welcome__want-more__title">
            {t("wantMore")}
          </p>
          <BaseButton
            onClick={() => {
              window.location.assign(`${process.env.REACT_APP_DOMAIN}sale`);
            }}
            className="ads-section-welcome__want-more__link"
          >
            {t("goToLink")}
          </BaseButton>
        </div>
      </div>
    </section>
  );
}
